(() => {
  function setup() {
    document.querySelectorAll('[data-ss20-cart-mobile]').forEach(link => {
      if (link.dataset.bozhiBound) return;
      link.dataset.bozhiBound = 'true';
      link.addEventListener('click', event => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(link);
        }
      });
    });
  }
  let cartRefreshTimer = 0;
  let cartRefreshController;
  function refreshCount() {
    clearTimeout(cartRefreshTimer);
    cartRefreshController?.abort();
    cartRefreshController = new AbortController();
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:cartRefreshController.signal})
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(cart => {
        if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        document.querySelectorAll('[data-ss20-count]').forEach(el => {
          if (el.textContent !== String(cart.item_count)) el.textContent = cart.item_count;
          el.classList.toggle('is-zero', cart.item_count === 0);
        });
      }).catch(() => {});
  }
  // Read the authoritative count after an Ajax cart mutation actually completes.
  // This covers app drawers that do not publish Dawn events, without patching fetch/XHR or polling.
  if (typeof PerformanceObserver === 'function') {
    try {
      const cartRequests = new PerformanceObserver(list => {
        const changed = list.getEntries().some(entry => {
          try {
            const url = new URL(entry.name, location.href);
            return url.origin === location.origin && /\/cart\/(?:add|change|update|clear)(?:\.(?:js|json))?\/?$/.test(url.pathname);
          } catch { return false; }
        });
        if (changed) {
          clearTimeout(cartRefreshTimer);
          cartRefreshTimer = setTimeout(refreshCount, 80);
        }
      });
      cartRequests.observe({type:'resource',buffered:true});
    } catch { /* Existing theme cart events remain the fallback. */ }
  }
  setup();
  refreshCount();
  document.addEventListener('shopify:section:load', setup);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
})();

/* Bozhi SS20 desktop: keep one quantity badge when a cart app injects another. */
(() => {
  const styleId = 'bozhi-single-desktop-cart-counter';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media (min-width:1024px) {
        [data-ss20] .ss20__right > [data-ss20-cart-mobile] { display:none!important; }
        [data-ss20] #cart-icon-bubble.bozhi-single-cart-counter {
          display:inline-flex!important; align-items:center!important; gap:7px!important;
        }
        [data-ss20] #cart-icon-bubble.bozhi-single-cart-counter > :not([data-bozhi-cart-label]):not([data-bozhi-cart-primary]):not(.visually-hidden) {
          display:none!important;
        }
        [data-ss20] #cart-icon-bubble.bozhi-single-cart-counter::before,
        [data-ss20] #cart-icon-bubble.bozhi-single-cart-counter::after,
        [data-ss20] #cart-icon-bubble [data-bozhi-cart-primary]::before,
        [data-ss20] #cart-icon-bubble [data-bozhi-cart-primary]::after {
          content:none!important; display:none!important;
        }
        [data-ss20] #cart-icon-bubble [data-bozhi-cart-primary] {
          position:static!important; inset:auto!important; transform:none!important;
          margin:0!important; flex:none; min-width:18px; height:18px;
          padding:0 5px; font-size:11px; line-height:1; box-sizing:border-box;
        }
        [data-ss20] #cart-icon-bubble [data-bozhi-cart-primary].is-zero { display:none!important; }
      }
    `;
    document.head.appendChild(style);
  }
  const controllers = new Map();
  function mount(headerRight) {
    if (controllers.has(headerRight)) return;
    function normalize() {
      const link = headerRight.querySelector('#cart-icon-bubble.ss20__desk');
      if (!link) return;
      const children = Array.from(link.children);
      const primary = children.find(el => el.matches('.ss20__count[data-ss20-count]'));
      const label = children.find(el => el.tagName === 'SPAN' &&
        !el.matches('[data-ss20-count], .ss20__count, .cart-count-bubble, .badge, .visually-hidden') &&
        /[^\d\s+]/.test(el.textContent));
      const active = Boolean(primary && label);
      link.classList.toggle('bozhi-single-cart-counter', active);
      children.forEach(el => {
        el.toggleAttribute('data-bozhi-cart-primary', active && el === primary);
        el.toggleAttribute('data-bozhi-cart-label', active && el === label);
      });
    }
    // Observe only header child replacement; counting and drawer events remain unchanged.
    const observer = new MutationObserver(normalize);
    observer.observe(headerRight, {childList:true, subtree:true});
    controllers.set(headerRight, observer);
    normalize();
  }
  function scan() {
    controllers.forEach((observer, node) => {
      if (!node.isConnected) { observer.disconnect(); controllers.delete(node); }
    });
    document.querySelectorAll('[data-ss20] .ss20__right').forEach(mount);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((observer, node) => {
      if (event.target.contains(node)) { observer.disconnect(); controllers.delete(node); }
    });
  });
})();
